import { StationDetail } from '@/types/price-comparison.types';
import { normalizeOptionList } from '@/pages/price-processing/price-processing.utils';

/**
 * Formats a price value to a fixed 2-decimal string representation
 * Returns '-' for null, undefined, empty, or invalid numeric values
 *
 * @param price - The price value to format (number, string, null, or undefined)
 * @returns Formatted price string with 2 decimal places or '-' if invalid
 */
export const formatPrice = (price: number | string | null | undefined): string => {
  if (price === null || price === undefined || price === '') return '-';
  const numPrice = typeof price === 'string' ? parseFloat(price) : price;
  if (isNaN(numPrice)) return '-';
  return numPrice.toFixed(2);
};

/**
 * Formats a price difference value with sign indicator
 * Adds '+' prefix for positive differences, '-' for negative, and returns '-' for zero or invalid values
 *
 * @param difference - The difference value to format (number, string, null, or undefined)
 * @returns Formatted difference string with sign and 2 decimal places or '-' if invalid
 */
export const formatDifference = (difference: number | string | null | undefined): string => {
  if (difference === null || difference === undefined || difference === '') return '-';
  const numDiff = typeof difference === 'string' ? parseFloat(difference) : difference;
  if (isNaN(numDiff)) return '-';
  const sign = numDiff > 0 ? '+' : '';
  return `${sign}${numDiff.toFixed(2)}`;
};

export const getSortedStation = (stationDetails: StationDetail[]) => {
  return [...stationDetails].sort((a, b) => {
    const brandA = a.brand || '';
    const brandB = b.brand || '';
    return brandA.localeCompare(brandB, 'uk', { sensitivity: 'base' });
  });
};

export const getSelectedSingle = (val?: string | string[]): string =>
  Array.isArray(val) ? (val[0] ?? '') : (val ?? '');

export const getSelectedMultiple = (val?: string | string[]): string[] =>
  val ? (Array.isArray(val) ? val : [val]) : [];

export const getFiltersNames = (
  data: any,
  key: 'regional_offices' | 'provinces' | 'brands' | 'statuses',
  defaultValue?: string
): string[] => {
  const items = normalizeOptionList(data?.[key]);
  return defaultValue ? [defaultValue, ...items] : items;
};

// const getFilterLabel = (key: string): string => {
//   const labels: { [key: string]: string } = {
//     regional_office: 'Регіональне відділення',
//     province: 'Область',
//     brand: 'Бренд'
//   };
//   return labels[key] || key;
// };

// export const getActiveFilters = (filters: PriceActionFilters) => {
//   return Object.entries(filters).flatMap(([key, val]) => {
//     const values: string[] = Array.isArray(val)
//       ? val.filter((v): v is string => v !== undefined && v !== null && v !== '')
//       : val
//         ? [val]
//         : [];

//     return values.map(v => ({
//       key: key as PriceActionFilterKey,
//       label: getFilterLabel(key),
//       value: v
//     }));
//   });
// };

// export const updateMultiSelect = (
//   key: 'province' | 'brand',
//   value: string,
//   prevValues: string[],
//   prov: string[],
//   br: string[]
// ): string[] => {
//   if (value === 'Всі') {
//     const options = key === 'province' ? prov.filter(p => p !== 'Всі') : br.filter(b => b !== 'Всі');
//     return options;
//   }

//   return prevValues.includes(value) ? prevValues : [...prevValues, value];
// };

// export const getUpdatedFilters = (
//   filters: PriceActionFilters,
//   filterKey: PriceActionFilterKey,
//   value: string,
//   provincesOptions: string[],
//   brandsOptions: string[]
// ): PriceActionFilters => {
//   let newFilters = { ...filters };

//   if (filterKey === 'regional_office') {
//     const rest = { ...newFilters };
//     delete rest.province;
//     delete rest.brand;
//     newFilters = {
//       ...rest,
//       regional_office: [value]
//     };
//   } else {
//     const prevValues: string[] = Array.isArray(newFilters[filterKey]) ? newFilters[filterKey] : [];
//     newFilters[filterKey] = updateMultiSelect(filterKey, value, prevValues, provincesOptions, brandsOptions);
//   }

//   return newFilters;
// };

// export const getFiltersAfterRemove = (
//   filters: PriceActionFilters,
//   key: PriceActionFilterKey,
//   value?: string
// ): PriceActionFilters => {
//   let newFilters = { ...filters };

//   if (value) {
//     const currentValues: string[] = Array.isArray(newFilters[key])
//       ? newFilters[key]
//       : [newFilters[key]].filter((v): v is string => Boolean(v));

//     const newValues = currentValues.filter(v => v !== value);

//     if (newValues.length === 0) {
//       delete newFilters[key];
//     } else {
//       newFilters[key] = newValues;
//     }
//   } else {
//     delete newFilters[key];
//   }

//   if (key === 'regional_office') {
//     const rest = { ...newFilters };
//     delete rest.province;
//     delete rest.brand;
//     newFilters = rest;
//   }

//   return newFilters;
// };
